import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import * as PropTypes from 'prop-types';
import Spinner from 'react-spinkit';

import digitLogo from '../../assets/img/brand/logo-digit-gris.svg';

// http://kyleamathews.github.io/react-spinkit/
function SpinkitSpinner({ name, loaderProps }) {
  return <Spinner name={name} {...loaderProps} />;
}

// https://material-ui.com/components/progress/
function MaterialProgress({ name, loaderProps }) {
  let loader = '';

  switch (name) {
    default:
    case 'circular':
      loader = <CircularProgress {...loaderProps} />;
      break;
    case 'linear':
      loader = <LinearProgress {...loaderProps} />;
      break;
  }

  return loader;
}

function DigitFullscreenSpinner() {
  return (
    <div className='loader-overlay'>
      <div className='loader'>
        <span className='flicker'>
          <img src={digitLogo} alt={'Chargement'} />
        </span>
      </div>
    </div>
  );
}

function Loading({ type, name, loaderProps }) {
  let loader = '';
  switch (type) {
    case Loading.TYPE.SPINKIT:
      loader = <SpinkitSpinner name={name} loaderProps={loaderProps} />;
      break;
    default:
    case Loading.TYPE.MATERIAL:
      loader = <MaterialProgress name={name} loaderProps={loaderProps} />;
      break;
    case Loading.TYPE.DIGIT_FULLSCREEN:
      loader = <DigitFullscreenSpinner />;
      break;
  }

  return loader;
}

Loading.TYPE = {
  SPINKIT: 'spinkit',
  MATERIAL: 'material',
  DIGIT_FULLSCREEN: 'digit_fullscreen',
};

Loading.propTypes = {
  type: PropTypes.oneOf([Loading.TYPE.SPINKIT, Loading.TYPE.MATERIAL, Loading.TYPE.DIGIT_FULLSCREEN]),
  loaderProps: PropTypes.object,
};

Loading.defaultProps = {
  type: Loading.TYPE.MATERIAL,
  name: 'circular',
  loaderProps: {},
};

export default Loading;
